export const COLOR_HEX_CONFIG = [
  { hex: '#DEC4AB', name: 'Tan', urlName: 'tan' },
  { hex: '#008000', name: 'Green', urlName: 'green' },
  { hex: '#808080', name: 'Grey', urlName: 'grey' },
  { hex: '#FF0000', name: 'Red', urlName: 'red' },
  { hex: '#ADD8E6', name: 'Light Blue', urlName: 'light_blue' },
  { hex: '#7F1734', name: 'Claret', urlName: 'claret' },
  { hex: '#000000', name: 'Black', urlName: 'black' },
  { hex: '#FFFF00', name: 'Yellow', urlName: 'yellow' },
  { hex: '#8C5A27', name: 'Brown', urlName: 'brown' },
  { hex: '#0000FF', name: 'Dark Blue', urlName: 'dark_blue' },
  { hex: '#000080', name: 'Navy', urlName: 'navy' },
  { hex: '#FFF5E1', name: 'Cream', urlName: 'cream' },
  { hex: '#FFC0CB', name: 'Pink', urlName: 'pink' },
  { hex: '#00FFFF', name: 'Aqua', urlName: 'aqua' },
  { hex: '#FFA500', name: 'Orange', urlName: 'orange' },
  { hex: '#FFFFFF', name: 'White', urlName: 'white' },
  { hex: '#800080', name: 'Purple', urlName: 'purple' },
  { hex: '#FFD700', name: 'Gold', urlName: 'gold' },
  { hex: '#F5F5DC', name: 'Beige', urlName: 'beige' },
  // { "hex": "#FF0000_ #FFA500,_#FFFF00_ #00FF00_ #0000FF_ #800080", "name": "Multi", "urlName": "multi" }
];
